import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";

const PetitionTable = ({ petitii, onDelete, onEdit }) => {
  const [sortKey, setSortKey] = useState(null);
  const [sortAsc, setSortAsc] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  const handleSort = (key) => {
    if (sortKey === key) {
      setSortAsc(!sortAsc);
    } else {
      setSortKey(key);
      setSortAsc(true);
    }
  };

  const filtered = petitii.filter((p) => {
    const haystack = (
      p.nume +
      " " +
      p.prenume +
      " " +
      p.email +
      " " +
      p.oras +
      " " +
      p.judet +
      " " +
      p.tara +
      " " +
      p.nume_petitie
    ).toLowerCase();
    return haystack.includes(searchTerm.toLowerCase());
  });

  const sorted = [...filtered].sort((a, b) => {
    if (!sortKey) return 0;
    const valA = a[sortKey]?.toLowerCase?.() ?? "";
    const valB = b[sortKey]?.toLowerCase?.() ?? "";
    if (valA < valB) return sortAsc ? -1 : 1;
    if (valA > valB) return sortAsc ? 1 : -1;
    return 0;
  });

  return (
    <div className="table-responsive neumorphic p-3 rounded">
      <input
        type="text"
        className="form-control mb-3"
        placeholder="Caută după nume, email, oraș, județ sau petiție..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      <table className="table table-bordered table-hover align-middle">
        <thead>
          <tr>
            <th onClick={() => handleSort("prenume")} style={{ cursor: "pointer" }}>
              Prenume
            </th>
            <th onClick={() => handleSort("nume")} style={{ cursor: "pointer" }}>
              Nume
            </th>
            <th>Email</th>
            <th>Telefon</th>
            <th>Oraș</th>
            <th>Județ</th>
            <th>Țara</th>
            <th onClick={() => handleSort("nume_petitie")} style={{ cursor: "pointer" }}>
              Nume Petiție
            </th>
            <th>Acțiuni</th>
          </tr>
        </thead>
        <tbody>
          {sorted.map((p, index) => (
            <tr key={index}>
              <td>{p.prenume}</td>
              <td>{p.nume}</td>
              <td>{p.email}</td>
              <td>{p.numar_telefon}</td>
              <td>{p.oras}</td>
              <td>{p.judet}</td>
              <td>{p.tara}</td>
              <td>{p.nume_petitie}</td>
              <td>
                <Dropdown
                  onSelect={(action) => {
                    if (action === "edit") onEdit(p);
                    else if (action === "delete") onDelete(index);
                  }}
                >
                  <Dropdown.Toggle variant="secondary" size="sm">
                    Acțiuni
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item eventKey="edit">Editează</Dropdown.Item>
                    <Dropdown.Item eventKey="delete" className="text-danger">
                      Șterge
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PetitionTable;
